import { parsePhoneNumber } from "libphonenumber-js/max";
import { NONXRAYMODALITIES } from "../constants/Constants";
import { getEnv } from './EnvHelper';

export const validatePhoneNumber =(inputNumber, country, t) => {
    const actualPhoneNumber = inputNumber.substring(country.dialCode.length);
    if(actualPhoneNumber.length !== 0){
      try {
        const phoneNumber = parsePhoneNumber( actualPhoneNumber, country.iso2.toUpperCase());
        if (phoneNumber) {
          if(!phoneNumber.isValid())
            return (`${t("string-literals.invalid-number")}`);
        }
      } catch (error) {
        return (`${t("string-literals.invalid-number")}`);
      }
    }
  }

  export const validatePhoneNumberWithCode =(inputNumber, countryCode, dialCode, t) => {
    if(inputNumber && countryCode && dialCode){
      const actualPhoneNumber = inputNumber.substring(dialCode.length +1);
      if(actualPhoneNumber.length !== 0){
        try {
          const phoneNumber = parsePhoneNumber( actualPhoneNumber, countryCode.toUpperCase());
          if (phoneNumber) {
            if(!phoneNumber.isValid())
              return (`${t("string-literals.invalid-number")}`);
          }
        } catch (error) {
          return (`${t("string-literals.invalid-number")}`);
        }
      }
    }
  }

  export const opneWeasisViewer=(studyId) =>{
    console.log(" study ID ", studyId);
    const weasisapi_URL = getEnv("REACT_APP_DICOM_ACCEPTOR_BASE_URL") + `"weasis/study/${studyId}/manifest"`;
    const url = `$dicom:get -w ${weasisapi_URL}`;
    console.log("weasis url", url);
    
    const encodedURL = encodeURIComponent(url);
    const weasisURL = "weasis://" + encodedURL;
    console.log(weasisURL);

    var wordInstance = document.createElement("a");
    wordInstance.id = "weasisStudy";
    var link = document.createTextNode("weasis link");
    wordInstance.appendChild(link);
    wordInstance.title = "ms-word";
    wordInstance.href = weasisURL;
    wordInstance.click();

  }

  export const openInfinitViewer=(accessionNumber,infinitViewerUrl) =>{
    // console.log(" accessionNumber ", accessionNumber);
    // const infinitViewerUrl = "https://pacs.carepointhealth.com/pkg_pacs/external_interface.aspx?TYPE=V&LID=cphaugmento&LPW=TEST123test&AN="+"A003990967BNJ";
    console.log(infinitViewerUrl);
    const newTab = window.open(infinitViewerUrl, '_blank');

  }

  export const generateRandomString=(userId, studyId) =>{
    return userId + "-" + studyId + "-" + Math.random().toString(36).substring(2, 10);
  }

  export const slateJsonToPlainText = (jsonString) => {
    try {
      const nodes = JSON.parse(jsonString);
      return nodes.map(n => {
      if (n.type === 'paragraph') {
      return n.children.map(child => {
        if (child.type === 'mention') {
        return child.character;
        }
        return child.text;
      }).join('');
      }
    return '';
      }).join('\n');
    } catch (e) {
      return jsonString;
    }
 };
  
  

  export const getRadiologistDisplayName = (person, payrollSuffix = "") => {
    if (!person) return "";
    const name =
      (person.firstName == null || person.firstName === undefined
        ? person.name ?? ""
        : `${person.firstName || ""} ${person.lastName || ""}`.trim()) + payrollSuffix;
    if (name.includes(" : ")) return name;
    const specialist =
      person.specialist != null ? String(person.specialist).trim() : "";
    if (!specialist || specialist.toLowerCase() === "false") return name;
    return `${name} : ${specialist}`;
  };

  export const getProviderNameWithoutSpecialist = (displayName) => {
    if (!displayName || typeof displayName !== "string") return displayName ?? "";
    const payrollSuffix = displayName.endsWith(" *") ? " *" : "";
    let base = payrollSuffix ? displayName.slice(0, -2).trim() : displayName.trim();
    const sep = base.lastIndexOf(" : ");
    if (sep > -1) base = base.slice(0, sep).trim();
    return base + payrollSuffix;
  };

  export const isImageAllowedToLLM = (modality, studyDescription) => {
    const LLM_RULES = [
        { modalities: ["CR", "DX", "RF"], studyDescriptions: ["UP_EXM", "LOW_EXM", "PELVIS", "Femur", "Humerus"] },
          { modalities: NONXRAYMODALITIES, studyDescriptions: ["CHEST"] }
        ];
        
        if (!modality || !studyDescription) return false;
        const normModality = modality.toUpperCase();
        const normDesc = studyDescription.toUpperCase();
    
        return LLM_RULES.some(rule =>
        rule.modalities.some(m => normModality === m.toUpperCase()) &&
        rule.studyDescriptions.some(desc => normDesc.includes(desc.toUpperCase())));
};

